import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface groupPermissionsDetail {
    id: number;
    name: string;
    code: string;
}

interface permissionsDetail {
    id: number;
    name: string;
    codename: string;
}

interface RoleDetailState {
    id: number;
    name: string;
    code: string;
    status: 0 | 1;
    description: string;
    group_permissions: groupPermissionsDetail[];
    permissions: permissionsDetail[];
    created_at: string;
    updated_at: string;
}

interface RoleData {
    roleList: RoleDetailState[];
}

const initialState: any = {
    roleList: [],
    roleCreation: {},
    loading: false,
    success: false,
    groupPermissionsList: [],
    permissionsList: [],
    loadingGroupPermissions: false,
    loadingPermissions: false
};

const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setSuccess(state, action) {
            state.success = action.payload;
        },
        setRoleList(state, action) {
            state.roleList = action.payload;
        },
        setRoleCreation(state, action) {
            state.roleCreation = action.payload;
        },
        clearRoleData(state) {
            state.roleList = [];
            state.roleCreation = {}
        },
        setGroupPermissionsList(state, action: PayloadAction<any>) {
            state.groupPermissionsList = action.payload
        },
        setPermissionsList(state, action: PayloadAction<any>) {
            state.permissionsList = action.payload
        },
        setLoadingGroupPermissions(state, action: PayloadAction<any>) {
            state.loadingGroupPermissions = action.payload
        },
        setLoadingPermissions(state, action: PayloadAction<any>) {
            state.loadingPermissions = action.payload
        }
    },
});

export const {
    setLoading,
    setSuccess,
    setRoleList,
    setRoleCreation,
    clearRoleData,
    setGroupPermissionsList,
    setPermissionsList,
    setLoadingGroupPermissions,
    setLoadingPermissions
} = roleSlice.actions;

export default roleSlice.reducer;
